import { useEffect, useMemo } from 'react';

export const useDeepCompareEffect = (callback, deps) => {
  checkDeps(deps);

  useEffect(callback, useDeepCompareDeps(deps));
};

export function useDeepCompareMemo<T>(callback, deps) {
  checkDeps(deps);

  return useMemo(callback, useDeepCompareDeps(deps));
}

const useDeepCompareDeps = deps =>
  deps.map(dep => {
    if (typeof dep === 'object' && dep !== null) {
      return JSON.stringify(dep);
    }
    return dep;
  });

const checkDeps = deps => {
  checkNoDeps(deps);

  if (deps.every(isPrimitive)) {
    throw new Error(
      "Custom hook useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React's useEffect instead."
    );
  }
};

const checkNoDeps = deps => {
  if (!deps || !deps.length) {
    throw new Error(
      "Custom hook useDeepCompareEffect should not be used with no dependencies. Use React's useEffect instead."
    );
  }
};

const isPrimitive = val => {
  return val == null || /^[sbn]/.test(typeof val);
};
